import { Tabs } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import useRegions from "../hooks/useRegions";
import { useSelector } from "react-redux";

export default function Services(...props) {
    const [activeTab, setActiveTab] = useState(null);
    const organisation = useSelector((state) => state.organisation.organisation);
    const regions = useRegions(organisation);

    const firstRegionId = useMemo(() => Object.keys(regions)[0], [regions]);

    useEffect(() => {
        if (!activeTab && firstRegionId) {
            setActiveTab(firstRegionId);
        }
    }, [activeTab, firstRegionId]);

    const handleOnTabChange = (key) => {
        setActiveTab(key);
    };

    const IFrameEmbed = ({ operatorId }) => {
        const src = useMemo(() => {
            if (!operatorId) return null;
            const url = `${process.env.PUBLIC_URL || ''}/busable-embed.html?operator_id=${operatorId}&views=timetables`;
            return url;
        }, [operatorId]);
        if (!src) return null;
        return (
            <iframe
                title={`timetables-${operatorId}`}
                src={src}
                style={{ border: "none", width: "100%", height: "1000px" }}
                sandbox="allow-scripts allow-same-origin"
            />
        );
    };

    // Simpler: inject script for active region into current tab pane


    return (
        <div className="Courses">
            <div className="AppContainer">
                <h1 className="SectionTitle">Services</h1>
                {activeTab && (
                    <Tabs
                        destroyInactiveTabPane
                        activeKey={activeTab}
                        onChange={handleOnTabChange}
                        items={Object.keys(regions).map((regionId) => {
                            return {
                                key: regionId,
                                label: regions[regionId]?.region_name,
                                children: (
                                    <>
                                        <IFrameEmbed operatorId={regionId} />
                                    </>
                                ),
                            };
                        })}
                    />
                )}
            </div>
        </div>
    );
}
